"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        ovalContainedButton: {
            height: '100%',
            width: 150,
            '&:hover': {
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.palette.primary.main,
                },
            },
        },
    });
});
var OvalContainedButton = function (_a) {
    var children = _a.children, _b = _a.href, href = _b === void 0 ? undefined : _b, _c = _a.onClick, onClick = _c === void 0 ? undefined : _c;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Button, { className: classes.ovalContainedButton, variant: "contained", color: "primary", size: "large", href: href, onClick: onClick }, children));
};
exports.default = OvalContainedButton;
